import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { Modal as MuiModal } from "@mui/material";
import JSZip from "jszip";
import React, { useEffect, useRef, useState } from "react";
import { Download, Search, Truck } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Select } from "semantic-ui-react";
import { getDocumentByOpeAndRef, getFile } from "../../api/documentUpload";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
} from "../../api/keyvalue";
import { tyreDropdown } from "../../api/tyreApi";
import {
  getVehicleDetailsDownload,
  searchVehicle,
  vehicleById,
  vehiclesByMultipleIds,
} from "../../api/vehicleapi";
import AnimatedIcon from "../../components/AnimatedIcon";
import Grid from "../../components/Grid";
import Button from "../../components/input/Button";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import LoadingSpinner from "../../components/LoadingSpinner";
import IconButtonRenderer from "../../components/renderer/IconButtonRenderer";
import SelectRenderer from "../../components/renderer/SelectRenderer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import JobVehicleStatus from "../../components/transaction/JobMonitor/VehicleStatus/JobVehicleStatus";
import AddVehicle from "../../components/vehicle/AddVehicle";
import { FORMS, MODULES, statusById } from "../../const";
import "../../css/CreationRequest.css";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import { errorActions } from "../../store/error-slice";
import { addAuditRecord } from "../../api/auditApi";
import useUserCompany from "../../hooks/useUserCompany";
import { formatFromJsonDate } from "../../dateConfig";
import VehicleStatusChange from "../../components/vehicle/VehicleStatusChange";
import Modal from "../../components/Modal";

const Vehicle = () => {
  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Master,
    section: FORMS.VEHICLE,
  });
  const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
  const statusPermission = auth?.[FORMS.VEHICLE.VEH_STATUS.form];
  const statusChangePermission = statusPermission?.FORM?.VIEW;
  const vehiclePermission = auth[FORMS.VEHICLE.VEH.form];
  const downloadPermission = vehiclePermission?.FORM?.DOWNLOAD;

  const [tab, setTab] = useState(1);
  const dispatch = useDispatch();
  const [isGalleryOpen, setGalleryOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editVehicle, setEditVehicle] = useState({}); // Edit Vehicle Data
  const [uomOptions, setUomOptions] = useState([]);
  const [featureDropdown, setFeatureDropdown] = useState([]);
  const [fuelTypeOpt, setFuelTypeOpt] = useState([]);
  const [specialStatusOpt, setSpecialStatusOpt] = useState([]);
  const [tyreSizeOpt, setTyreSizeOpt] = useState([]);
  const [bodyTypeOpt, setBodyTypeOpt] = useState([]);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);
  const [inspectionTimeOpt, setInspectionTimeOpt] = useState([]);
  const [vpyCategoryOpt, setVpyCategoryOpt] = useState([]);
  const [vckTypeOpt, setVckTypeOpt] = useState([]);
  const [vckConditionOpt, setVckConditionOpt] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [extensionOptions, setExtensionOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [breakdownCategoryOpt, setBreakdownCategoryOpt] = useState([]);
  const [accidentStatusOpt, setAccidentStatusOpt] = useState([]);
  const [vehAuthorizedOpt, setVehAuthorizedOpt] = useState([]);
  const [inspecGroupOpt, setInspectGroup] = useState([]);
  const [vehRateTypeOpt, setVehRateTypeOpt] = useState([]);
  const [inscoverageOpt, setInscoverageOpt] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);
  const gridRef = useRef(null);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const [searchResult, setSearchResult] = useState([]);

  const [transporter, setTransporter] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [types, setTypes] = useState("");
  const [gpsProvider, setGpsProvider] = useState("");
  const [status, setStatus] = useState("");
  const [active, setActive] = useState("");
  const vehicleCodeRef = useRef("");
  const vehicleNoRef = useRef("");
  const [dataFetchLoading, setDataFetchLoading] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [noImagesMessage, setNoImagesMessage] = useState(false);
  const fromDateRef = useRef(null);
  const [vehId, setVehId] = useState("");
  const toDateRef = useRef(null);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [yesNoOptions, setYesNoOptions] = useState([]);
  const [baseDriverId, setBaseDriverId] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);

  const company = useUserCompany();
  const user = useSelector((state) => state.user);

  const handleReset = (e) => {
    e.preventDefault();
    if (vehicleCodeRef.current.value) {
      vehicleCodeRef.current.value = "";
    }
    if (vehicleNoRef.current.value) {
      vehicleNoRef.current.value = "";
    }

    setTransporter("");
    setManufacturer("");
    setGpsProvider("");
    setStatus("");
    setActive("");
    setSearchResult([]);
    setSearchFieldReset(true);
    toDateRef.current.reset();
    fromDateRef.current.reset();

    if (tab === 1) {
      setSearchClicked(false);
      setResetVisible(false);
    }
  };

  const location = useLocation();

  const handleCloseGallery = () => {
    setGalleryOpen(false);
  };

  const handleViewImageClick = async (vehicleId) => {
    setIsLoading(true);

    try {
      const documents = await getDocumentByOpeAndRef(4, vehicleId);

      if (documents && documents.length > 0) {
        const imageDocs = documents.filter(
          (doc) =>
            doc.docName.endsWith(".jpg") ||
            doc.docName.endsWith(".jpeg") ||
            doc.docName.endsWith(".png"),
        );

        if (imageDocs.length > 0) {
          const imagePromises = imageDocs.map(async (doc) => {
            const fileData = await getFile(doc.docId);

            const blob = new Blob([fileData], { type: "image/jpeg" });
            const url = URL.createObjectURL(blob);

            return {
              url: url,
              name: doc.docName || `Image-${Date.now()}`,
            };
          });

          const images = await Promise.all(imagePromises);

          setGalleryImages(images);
          setNoImagesMessage(false);
        } else {
          setNoImagesMessage(true);
          setGalleryImages([]);
        }
      } else {
        setNoImagesMessage(true);
        setGalleryImages([]);
      }
    } catch (error) {
      console.error("Error fetching images: ", error);
    }

    setIsLoading(false);
    setGalleryOpen(true);
  };

  const viewImageRenderer = (params) => {
    const handleClick = (e) => {
      e.stopPropagation();
      console.log("Vehicle params", params);
      // handleViewImageClick(params.data.vehId);
      setVehId(params.data.vehId);
      setBaseDriverId(params.data.vehBasedDriver);
      setGalleryOpen(true);
    };

    return (
      <Button
        className="ui primary button"
        style={{ display: "flex", alignItems: "center" }}
        onClick={handleClick}
        label="View Image"
      />
    );
  };

  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);

    if (selectedData.length > 0) {
      setSelectedVehicleIds(selectedData?.map((item) => item.vehId));
    }
  };

  const handleBulkDownload = async () => {
    await addAuditRecord({
      company: company ? company.comId : null,
      action: "Vehicle Image Download",
      params: selectedRows.map((item) => item.vehId).join(",").toString(),
      type: 6,
      module: 5,
      user: user.username,
    });

    setIsDownloadLoading(true);

    const zip = new JSZip();
    let totalFilesAdded = 0;

    for (const vehicle of selectedRows) {
      const documents = await getDocumentByOpeAndRef(4, vehicle.vehId);

      if (documents && documents.length > 0) {
        const folderName = vehicle.vehVehicleNo || `vehicle-${vehicle.vehId}`;
        const vehicleFolder = zip.folder(folderName);

        for (const doc of documents) {
          const fileData = await getFile(doc.docId);

          if (fileData) {
            vehicleFolder.file(doc.docName, fileData);
            totalFilesAdded++;
          }
        }
      } else {
        toast.warn(`No documents found for vehicle ${vehicle.vehVehicleNo}.`, {
          autoClose: 5000,
          containerId: "Main",
        });
      }
    }

    if (totalFilesAdded > 0) {
      const content = await zip.generateAsync({ type: "blob" });
      const url = URL.createObjectURL(content);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Vehicle-Images.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }

    setIsDownloadLoading(false);
  };

  const getFileType = (mimeType) => {
    if (mimeType.includes("pdf")) return ".pdf";
    if (mimeType.includes("csv")) return ".csv";
    if (mimeType.includes("xlsx")) return ".xlsx";
    if (mimeType.includes("word") || mimeType.includes("document"))
      return ".docx";
    if (mimeType.includes("jpeg")) return ".jpeg";
    if (mimeType.includes("jpg")) return ".jpg";
    if (mimeType.includes("png")) return ".png";
    return "";
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      //new
      const {
        vehicle_feature: vehicleFeatureOpt,
        active,
        status,
        fuel_type: fuelTypeOpt,
        uom: uomOpt,
        yesno: yesNoOpt,
        vpy_category: vpyCategoryOpt,
        body_type: bodyTypeOpt,
        inspection_time: inspectionTimeOpt,
        veh_check_condition: vehCheckConditionOpt,
        doc_type: docTypeOpt,
        file_type: fileTypeOpt,
        "file_name#4": fileNameOpt,
        vac_category: vacCategoryOpt,
        accident_status: accidentStatusOpt,
        emp_authorized: vehAuthorizedOpt = [],
        veh_inspection_group: inspecGroupOpt = [],
        veh_rate_type: vehRateTypeOpt = [],
        required: inscoverageOpt = [],
        vehicle_status: specStatusOpt = [],
      } = await getBulkDropdownData([
        { key: "vehicle_feature" },
        { key: "active" },
        { key: "status" },
        { key: "fuel_type" },
        { key: "uom" },
        { key: "yesno" },
        { key: "vpy_category" },
        { key: "body_type" },
        { key: "inspection_time" },
        { key: "veh_check_condition" },
        { key: "doc_type" },
        { key: "file_type" },
        { key: "file_name", group: "4" },
        { key: "vac_category" },
        { key: "accident_status" },
        { key: "emp_authorized" },
        { key: "veh_inspection_group" },
        { key: "veh_rate_type" },
        { key: "required" },
        { key: "vehicle_status" },
      ]);

      setFeatureDropdown(vehicleFeatureOpt);
      setActiveOpt(active);
      setStatusOpt(status);
      setFuelTypeOpt(fuelTypeOpt);
      setUomOptions(uomOpt);
      setYesNoOptions(yesNoOpt);
      setVpyCategoryOpt(vpyCategoryOpt);
      setBodyTypeOpt(bodyTypeOpt);
      setInspectionTimeOpt(inspectionTimeOpt);
      setVckConditionOpt(vehCheckConditionOpt);
      setDocumentTypeOptions(docTypeOpt);
      setExtensionOptions(fileTypeOpt);
      setFileNameOptions(fileNameOpt);
      setBreakdownCategoryOpt(vacCategoryOpt);
      setAccidentStatusOpt(accidentStatusOpt);
      setVehAuthorizedOpt(vehAuthorizedOpt);
      setInspectGroup(inspecGroupOpt);
      setVehRateTypeOpt(vehRateTypeOpt);
      setInscoverageOpt(inscoverageOpt);
      setSpecialStatusOpt(specStatusOpt);

      const tyreData = await tyreDropdown();
      setTyreSizeOpt(tyreData);

      const vckTypeData = await getDropdownData("veh_check", "", [
        "keyValue2",
        "keyValue3",
      ]);
      setVckTypeOpt(vckTypeData);

      console.log("finished fetching dropdown");

      setIsLoading(false);
    })();
  }, []);

  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const handleSearch = async (e) => {
    e.preventDefault();
    setIsSearchLoading(true);
    if (tab === 1) {
      setActiveAccordion1(false);
      setResetVisible(true);
      setSearchClicked(true);
    }

    const response = await searchVehicle({
      lactive: active,
      scode: vehicleCodeRef.current.value,
      lstatus: status,
      svehNo: vehicleNoRef.current.value,
      lmanufact: manufacturer,
      ltransporter: transporter,
      lgpsProvider: gpsProvider,
      lvehicleType: types,
      lToDate: toDateRef.current.value,
      lFromDate: fromDateRef.current.value,
    });

    const mappedResponse = response.map((item) => ({
      ...item,
      // statusInfo: statusById[item.vehStatus],
    }));

    setSearchResult(mappedResponse);
    setIsSearchLoading(false);
  };

  const handleDrawerOpen = () => {
    setEditMode(false);
    setEditVehicle({});
    setDrawerOpen(true);
    setTab(1);
    dispatch(errorActions.clearVehicleError());
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const vehicleTypeRenderer = (params) => {
    if (params.value) {
      const vehicleTypes = params.value.split(",");

      const options = vehicleTypes.map((vehicleType) => ({
        key: vehicleType,
        text: vehicleType,
        value: vehicleType,
      }));
      const handleChange = (selectedValue) => {};

      if (vehicleTypes.length > 1) {
        return (
          <SelectRenderer
            onChangeHandler={handleChange}
            value={null}
            placeholder="Select Vehicle Type"
            options={options}
          />
        );
      } else {
        return <div>{params.value}</div>;
      }
    }
    return null;
  };

  const getActionMenuOptions = () => {
    const actionMenuOptions = [
      {
        key: 2,
        text: "Change Status",
        value: 2,
      },
      {
        key: 3,
        text: "Details Download",
        value: 3,
      },
    ];
    if (downloadPermission) {
      actionMenuOptions.push({
        key: 1,
        text: "Image Download",
        value: 1,
      });
    }
    return actionMenuOptions;
  };
  const handleStatusChange = () => {
    setIsModalOpen(true);
    modalRef.current?.showModal();
    console.log("vehicle permission", statusChangePermission);
  };

  const actionsMenuChange = (data) => {
    switch (data.value) {
      case 1:
        handleBulkDownload();

        break;

      case 2:
        handleStatusChange();
        break;

      case 3:
        handleDownload();
        break;

      default:
        break;
    }
  };

  const handleDownload = async () => {
    await addAuditRecord({
      company: company ? company.comId : null,
      action: "Vehicle Details Download",
      params: selectedVehicleIds.join(",").toString(),
      type: 5,
      module: 2,
      user: user.username,
    });

    setIsDownloading(true);
    const excelBlob = await getVehicleDetailsDownload(selectedVehicleIds);
    if (!excelBlob || excelBlob.size === 0) {
      setIsDownloading(false);
      return;
    }
    const fileName = `REPORT OF VEHICLE DETAILS .xlsx`;

    const url = window.URL.createObjectURL(excelBlob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    setSelectedRows([]);
    setSelectedVehicleIds([]);
    setIsDownloading(false);
  };

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-around",
        }}
      >
        <div className="ui tabular top attached menu">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Truck size={15} style={{ marginRight: "5px" }} />
            </span>
            Vehicle Search
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "0px",
          }}
          className="ui tabular menu top attached"
        >
          <Button
            template="drawerOpen"
            disabled={firstViableTab === -1}
            onClick={handleDrawerOpen}
            authenticated={true}
            form={FORMS.VEHICLE.VEH.form}
            module={MODULES.Master}
            editMode={false}
          />
        </div>
      </div>
      {/* {selectedRows.length > 0 && downloadPermission && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px 0",
              }}
            >
              <Button
                isLoading={isDownloadLoading}
                onClick={handleBulkDownload}
                label="Download"
              />
            </div>
          )} */}
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header">Vehicle</h4>
                <div className="five fields">
                  <div className="field">
                    <label>Veh. Code</label>
                    <input
                      type="text"
                      placeholder="Veh. Code"
                      defaultValue={""}
                      defaultChecked={""}
                      name="vehCode"
                      ref={vehicleCodeRef}
                    />
                  </div>
                  <div className="field">
                    <label>Veh. No</label>
                    <input
                      type="text"
                      placeholder="Ex: LG-0123,SP-1234,AB-1009"
                      defaultValue={""}
                      name="vehNo"
                      ref={vehicleNoRef}
                    />
                  </div>

                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setTransporter("");
                    }}
                    onResultSelect={(data) => setTransporter(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                  />

                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setManufacturer("");
                    }}
                    onResultSelect={(data) => setManufacturer(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "manufacturer",
                      value: "",
                    }}
                    label="Manufacturer"
                  />
                  <SearchDropdown
                    key={1}
                    editMode={false}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    onClear={() => {
                      setGpsProvider("");
                    }}
                    onResultSelect={(data) => setGpsProvider(data)}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Supplier",
                    }}
                    label="GPS Provider"
                  />
                </div>

                <div className="five fields">
                  <div className="field">
                    <SearchDropdown
                      key={1}
                      editMode={false}
                      reset={searchFieldReset}
                      setReset={setSearchFieldReset}
                      clearable={true}
                      onClear={() => {
                        setTypes("");
                      }}
                      onResultSelect={(data) => setTypes(data)}
                      api={getOtherRefSearchDropdown}
                      apiDependency={{
                        type: "vehicle_type",
                        value: "",
                      }}
                      label="Vehicle Type"
                    />
                  </div>
                  <Input
                    label="From Date"
                    type="date"
                    name="lFromDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="lToDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                  <div className="field">
                    <label>Status</label>
                    <Select
                      clearable
                      options={specialStatusOpt}
                      placeholder="Status"
                      style={{ height: "20px" }}
                      value={status}
                      onChange={(e, data) => {
                        setStatus(data.value);
                      }}
                    />
                  </div>

                  <div className="field">
                    <label>Active</label>
                    <Select
                      clearable
                      options={activeOpt}
                      placeholder="active"
                      style={{ height: "20px" }}
                      value={active}
                      onChange={(e, data) => {
                        setActive(data.value);
                      }}
                    />
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field">
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearch(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "5px",
                  }}
                >
                  {selectedRows.length > 0 && downloadPermission && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 0 0 0",
                      }}
                    >
                      <Button
                        isLoading={isDownloadLoading}
                        Icon={Download}
                        onClick={handleBulkDownload}
                        label="Image Download"
                      />
                    </div>
                  )}
                  {selectedRows?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px 0 0 0",
                      }}
                    >
                      <Button
                        isLoading={isDownloading}
                        Icon={Download}
                        onClick={handleDownload}
                        label="Details"
                      />
                    </div>
                  )}
                </div> */}

                <Grid
                  ref={gridRef}
                  isLoading={dataFetchLoading}
                  content={searchResult}
                  multiRowSelection={true}
                  onSelectionChanged={handleSelectionChanged}
                  rowSelection="multiple"
                  handleActionMenuChange={actionsMenuChange}
                  showActionMenu={selectedRows.length > 0}
                  actionMenuOptions={getActionMenuOptions()}
                  domLayout="autoHeight"
                  config={[
                    {
                      headerName: "Vehicle No",
                      field: "vehVehicleNo",
                      checkboxSelection: true,
                      headerCheckboxSelection: true,
                    },
                    {
                      headerName: "Transporter",
                      field: "vehTransporterName",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Manufacturer",
                      field: "mnuManufacturer",
                    },
                    {
                      headerName: "Model",
                      field: "modModel",
                    },
                    {
                      headerName: "Vehicle Type",
                      field: "vehicleType",
                      cellRenderer: vehicleTypeRenderer,
                    },
                    // {
                    //   headerName: "Image",
                    //   field: "viewImg",
                    //   cellRenderer: viewImageRenderer,
                    // },
                    {
                      headerName: "Status",
                      field: "statusInfo",
                      cellRenderer: StatusCellStyle,
                    },
                    {
                      headerName: "Active",
                      field: "activeInfo",
                      cellRenderer: ActiveCellStyle,
                    },
                    {
                      field: "View",
                      minWidth: 90,
                      width: 90,
                      cellStyle: { backgroundColor: "white" },
                      cellRenderer: IconButtonRenderer,
                      cellRendererParams: (params) => ({
                        clickHandler: () => {
                          setVehId(params.data.vehId);
                          setBaseDriverId(params.data.vehBasedDriver);
                          setGalleryOpen(true);
                        },
                        icon: (
                          <AnimatedIcon
                            icon={faCamera}
                            color="black"
                            size="15px"
                            beatDuration="1s"
                          />
                        ),
                        style: { width: "50px" },
                      }),
                      pinned: "right",
                    },
                  ]}
                  onCellDoubleClicked={async (props) => {
                    if (
                      props.colDef.field !== "vehicleType" &&
                      props.colDef.field !== "viewImg"
                    ) {
                      setDataFetchLoading(true);
                      const response = await vehicleById(props.data.vehId);
                      setEditVehicle(response);
                      dispatch(errorActions.clearVehicleError());
                      setEditMode(true);
                      setDrawerOpen(true);
                      setDataFetchLoading(false);
                    }
                  }}
                />
              </>
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <div className="drawer-header">
              <div
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>Vehicle Code: {editVehicle?.vehicleDetail?.vehCode}</h3>
              </div>
            </div>
          ) : null
        }
        body={
          <AddVehicle
            isOpen={isDrawerOpen}
            editMode={editMode}
            setEditMode={setEditMode}
            currentValues={editVehicle}
            onClose={handleDrawerClose}
            dropdown={{
              featureDropdown,
              fuelTypeOpt,
              tyreSizeOpt,
              uomOptions,
              bodyTypeOpt,
              statusOpt,
              activeOpt,
              inspectionTimeOpt,
              vpyCategoryOpt,
              vckTypeOpt,
              vckConditionOpt,
              documentTypeOptions,
              extensionOptions,
              fileNameOptions,
              breakdownCategoryOpt,
              accidentStatusOpt,
              yesNoOptions,
              vehAuthorizedOpt,
              inspecGroupOpt,
              vehRateTypeOpt,
              inscoverageOpt,
              specialStatusOpt,
            }}
            isLoading={isLoading}
            searchTag={location.hash}
          />
        }
        style={{ width: "70vw", boxShadow: "none" }}
      />
      <div style={{ height: "200px" }}>
        <Modal
          ref={modalRef}
          open={isModalOpen}
          minWidth={"60vw"}
          style={{ height: "50vh" }}
          onClose={() => setIsModalOpen(false)}
        >
          <VehicleStatusChange
            vehIds={selectedVehicleIds}
            closeModal={() => modalRef.current?.close()}
          />
        </Modal>
      </div>
      <MuiModal open={isGalleryOpen} onClose={handleCloseGallery}>
        <div className="gallery-popup">
          {noImagesMessage ? (
            <div className="no-images-message">
              <h3>No images related to this vehicle.</h3>
            </div>
          ) : (
            // <GalleryComp images={galleryImages} />
            <JobVehicleStatus
              vehicleId={vehId}
              // driverId={baseDriverId}
              vehicleInfoOnly={true}
              // isHideTabs={true}
            />
          )}
        </div>
      </MuiModal>
    </>
  );
};

export default Vehicle;
